import { useMutation, useQueryClient } from "react-query";
import { updateRoleUsers } from "~/components/Forms/UsersForm/rolesRequest/updateRoleUsers";

export default function useUpdateUsers() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ roleDatas }: { roleDatas: any }) => {
      const url = `/internal-api/user`;
      const method = "PUT";
      return updateRoleUsers(url, method, roleDatas);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["getUsers"]);
      },
      onError: (error) => {
        console.error("Ошибка мутации:", error);
      },
    }
  );
}
